module.exports = __webpack_public_path__ + "8014b5be0621ec8b6d827dde3e4f4733.pdf";